var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/devices/s550/s550-config.ts
var TONES_PER_BLOCK = 32;
var WAVE_BANKS_PER_BLOCK = 2;
var BLOCK_COUNT = 2;
var WAVE_BANK_ADDRESSES = {
  /** Bank A - Block 1, bank 0 */
  A: [1, 0, 0, 0],
  /** Bank B - Block 1, bank 1 */
  B: [1, 32, 0, 0],
  /** Bank C - Block 2, bank 0 */
  C: [1, 64, 0, 0],
  /** Bank D - Block 2, bank 1 */
  D: [1, 96, 0, 0]
};
var BLOCK_WAVE_BANKS = {
  1: [0, 1],
  // Block 1: Banks A and B
  2: [2, 3]
  // Block 2: Banks C and D
};
var BLOCK_INFO = {
  1: {
    block: 1,
    firstToneIndex: 0,
    lastToneIndex: 31,
    waveBanks: BLOCK_WAVE_BANKS[1]
  },
  2: {
    block: 2,
    firstToneIndex: 32,
    lastToneIndex: 63,
    waveBanks: BLOCK_WAVE_BANKS[2]
  }
};
var S550_ADDRESSES = {
  /** System parameters base address */
  system: [0, 0, 0, 0],
  /** Patch parameters base address */
  patchBase: [0, 0, 0, 0],
  /** Tone parameters base address */
  toneBase: [0, 3, 0, 0],
  /** Wave data base address */
  waveData: [1, 0, 0, 0]
};
var S550_CONFIG = {
  modelId: 30,
  deviceName: "S-550",
  // Memory layout (inverted from S-330)
  patchCount: 32,
  toneCount: 64,
  waveBankCount: 4,
  // Value ranges
  maxToneIndex: 63,
  maxWaveBank: 3,
  maxPatchIndex: 31,
  // Address constants
  addresses: S550_ADDRESSES,
  // Block sizes (same as S-330)
  patchBlockSize: 512,
  toneBlockSize: 256,
  patchBlockNibbles: 1024,
  toneBlockNibbles: 512,
  toneStride: 2,
  toneMapEntries: 109
};

// src/devices/roland-s-series/s-series-constants.ts
var ROLAND_ID = 65;
var S_SERIES_MODEL_ID = 30;
var DEFAULT_DEVICE_ID = 0;
var S_SERIES_COMMANDS = {
  /** Data Request (host to device) */
  RQ1: 17,
  /** Data Set (host to device) */
  DT1: 18,
  /** Want to Send Data (bulk dump initiate) */
  WSD: 64,
  /** Request Data (bulk dump request) */
  RQD: 65,
  /** Data Transfer (bulk dump packet) */
  DAT: 66,
  /** Acknowledge */
  ACK: 67,
  /** End of Data */
  EOD: 69,
  /** Communication Error */
  ERR: 78,
  /** Rejection */
  RJC: 79
};
var ERROR_CODES = {
  CHECKSUM: 0,
  UNKNOWN_COMMAND: 1,
  WRONG_FORMAT: 2,
  MEMORY_FULL: 3,
  OUT_OF_RANGE: 4
};
var TIMING = {
  /** Minimum inter-byte delay in ms */
  INTER_BYTE_DELAY_MS: 1,
  /** ACK response timeout in ms */
  ACK_TIMEOUT_MS: 500,
  /** Retry delay after error in ms */
  RETRY_DELAY_MS: 100,
  /** Maximum retry attempts */
  MAX_RETRIES: 3,
  /** Maximum bytes per DAT packet */
  MAX_PACKET_SIZE: 256
};
var VALUE_RANGES = {
  /** Device ID range */
  DEVICE_ID: { min: 0, max: 31 },
  /** MIDI channel range */
  MIDI_CHANNEL: { min: 0, max: 15 },
  /** Pitch bend range (semitones) */
  BENDER_RANGE: { min: 0, max: 12 },
  /** Standard 7-bit parameter */
  STANDARD_7BIT: { min: 0, max: 127 }
};
var BULK_DUMP_TYPES = {
  ALL_PATCHES: 0,
  ALL_TONES: 1,
  SINGLE_PATCH: 2,
  SINGLE_TONE: 3,
  WAVE_DATA: 4,
  ALL_DATA: 127
};

// src/devices/roland-s-series/s-series-device-limits.ts
var S550_DEVICE_LIMITS = {
  sourcetoneMask: 63,
  waveBankMask: 3,
  copySourceMask: 63,
  maxPatchNumber: 31,
  maxToneNumber: 63
};

// src/devices/roland-s-series/s-series-addresses.ts
var PATCH_COMMON_OFFSETS = {
  NAME: 0,
  // 12 bytes
  BENDER_RANGE: 12,
  AFTERTOUCH_SENS: 14,
  KEY_MODE: 15,
  VELOCITY_THRESHOLD: 16,
  TONE_LAYER_1: 17,
  // 109 entries
  TONE_LAYER_2: 126,
  // 109 entries
  COPY_SOURCE: 235,
  OCTAVE_SHIFT: 284,
  LEVEL: 285,
  DETUNE: 287,
  VELOCITY_MIX_RATIO: 288,
  AFTERTOUCH_ASSIGN: 289,
  KEY_ASSIGN: 290,
  OUTPUT_ASSIGN: 291
};
var PATCH_TOTAL_SIZE = 512;
var PATCH_PARAMS = {
  name: {
    name: "Name",
    address: [0, 0],
    byteOffset: 0,
    size: 12
  },
  benderRange: {
    name: "Bender Range",
    address: [0, 24],
    byteOffset: 12,
    size: 1
  },
  aftertouchSens: {
    name: "A.T. Sensitivity",
    address: [0, 28],
    byteOffset: 14,
    size: 1
  },
  keyMode: {
    name: "Key Mode",
    address: [0, 30],
    byteOffset: 15,
    size: 1
  },
  velocityThreshold: {
    name: "V-Sw Threshold",
    address: [0, 32],
    byteOffset: 16,
    size: 1
  },
  toneLayer1: {
    name: "Tone Layer 1",
    address: [0, 34],
    byteOffset: 17,
    size: 109
  },
  toneLayer2: {
    name: "Tone Layer 2",
    address: [1, 124],
    byteOffset: 126,
    size: 109
  },
  copySource: {
    name: "Copy Source",
    address: [3, 86],
    byteOffset: 235,
    size: 1
  },
  octaveShift: {
    name: "Octave Shift",
    address: [3, 88],
    byteOffset: 236,
    size: 1
  },
  level: {
    name: "Level",
    address: [3, 90],
    byteOffset: 237,
    size: 1
  },
  detune: {
    name: "Detune",
    address: [3, 94],
    byteOffset: 239,
    size: 1
  },
  velocityMixRatio: {
    name: "V-Mix Ratio",
    address: [3, 96],
    byteOffset: 240,
    size: 1
  },
  aftertouchAssign: {
    name: "A.T. Assign",
    address: [3, 98],
    byteOffset: 241,
    size: 1
  },
  keyAssign: {
    name: "Key Assign",
    address: [3, 100],
    byteOffset: 242,
    size: 1
  },
  outputAssign: {
    name: "Output Assign",
    address: [3, 102],
    byteOffset: 243,
    size: 1
  }
};
var TONE_MAP_ENTRIES = 109;
var TONE_OFFSETS = {
  // === Basic Info ===
  NAME: 0,
  OUTPUT_ASSIGN: 8,
  SOURCE_TONE: 9,
  ORIG_SUB_TONE: 10,
  SAMPLING_FREQ: 11,
  ORIG_KEY_NUMBER: 12,
  WAVE_BANK: 13,
  WAVE_SEGMENT_TOP: 14,
  WAVE_SEGMENT_LENGTH: 15,
  // === Wave Points (24-bit addresses) ===
  START_POINT: 16,
  END_POINT: 19,
  LOOP_POINT: 22,
  LOOP_MODE: 25,
  // === LFO Parameters ===
  TVA_LFO_DEPTH: 26,
  LFO_RATE: 28,
  LFO_SYNC: 29,
  LFO_DELAY: 30,
  LFO_MODE: 32,
  TVA_LFO_DEPTH_2: 33,
  LFO_POLARITY: 34,
  LFO_OFFSET: 35,
  // === Pitch Parameters ===
  TRANSPOSE: 36,
  FINE_TUNE: 37,
  // === TVF Parameters ===
  TVF_CUTOFF: 38,
  TVF_RESONANCE: 39,
  TVF_KEY_FOLLOW: 40,
  TVF_LFO_DEPTH: 42,
  TVF_EG_DEPTH: 43,
  TVF_EG_POLARITY: 44,
  TVF_LEVEL_CURVE: 45,
  TVF_KEY_RATE_FOLLOW: 46,
  TVF_VEL_RATE_FOLLOW: 47,
  TVF_SWITCH: 49,
  // === Bender Switch ===
  BENDER_SWITCH: 50,
  // === TVA Envelope Config ===
  TVA_ENV_SUSTAIN_POINT: 51,
  TVA_ENV_END_POINT: 52,
  // === TVA Envelope Points 1-8 ===
  TVA_ENV_LEVEL_1: 53,
  TVA_ENV_RATE_1: 54,
  TVA_ENV_LEVEL_2: 55,
  TVA_ENV_RATE_2: 56,
  TVA_ENV_LEVEL_3: 57,
  TVA_ENV_RATE_3: 58,
  TVA_ENV_LEVEL_4: 59,
  TVA_ENV_RATE_4: 60,
  TVA_ENV_LEVEL_5: 61,
  TVA_ENV_RATE_5: 62,
  TVA_ENV_LEVEL_6: 63,
  TVA_ENV_RATE_6: 64,
  TVA_ENV_LEVEL_7: 65,
  TVA_ENV_RATE_7: 66,
  TVA_ENV_LEVEL_8: 67,
  TVA_ENV_RATE_8: 68,
  // === TVA Additional Parameters ===
  TVA_KEY_RATE: 70,
  TVA_LEVEL: 71,
  TVA_VEL_RATE: 72,
  REC_THRESHOLD: 73,
  REC_PRE_TRIGGER: 74,
  REC_SAMPLING_FREQ: 75,
  REC_START_POINT: 76,
  REC_END_POINT: 79,
  REC_LOOP_POINT: 82,
  ZOOM_T: 85,
  ZOOM_L: 86,
  COPY_SOURCE: 87,
  LOOP_TUNE: 88,
  TVA_LEVEL_CURVE: 89,
  // === Loop Length ===
  LOOP_LENGTH: 102,
  // === Additional Settings ===
  PITCH_FOLLOW: 105,
  ENV_ZOOM: 106,
  // === TVF Envelope Config ===
  TVF_ENV_SUSTAIN_POINT: 107,
  TVF_ENV_END_POINT: 108,
  // === TVF Envelope Points 1-8 ===
  TVF_ENV_LEVEL_1: 109,
  TVF_ENV_RATE_1: 110,
  TVF_ENV_LEVEL_2: 111,
  TVF_ENV_RATE_2: 112,
  TVF_ENV_LEVEL_3: 113,
  TVF_ENV_RATE_3: 114,
  TVF_ENV_LEVEL_4: 115,
  TVF_ENV_RATE_4: 116,
  TVF_ENV_LEVEL_5: 117,
  TVF_ENV_RATE_5: 118,
  TVF_ENV_LEVEL_6: 119,
  TVF_ENV_RATE_6: 120,
  TVF_ENV_LEVEL_7: 121,
  TVF_ENV_RATE_7: 122,
  TVF_ENV_LEVEL_8: 123,
  TVF_ENV_RATE_8: 124,
  // === Aftertouch Switch ===
  AFTERTOUCH_SWITCH: 125
};
var TONE_BLOCK_SIZE = 256;
var TONE_BLOCK_NIBBLES = 512;
function buildPatchAddress(patchNumber, offset) {
  return [0, 0, patchNumber * 4 & 127, offset & 127];
}
function buildPatchParamAddress(patchIndex, param) {
  const [high, low] = param.address;
  return [0, 0, patchIndex * 4 + high & 127, low & 127];
}
function buildToneAddress(toneNumber, offset) {
  const byte2 = toneNumber * 2;
  return [0, 3, byte2 & 127, offset & 127];
}
function buildSystemAddress(offset) {
  return [0, 0, 0, offset & 127];
}

// src/devices/roland-s-series/s-series-messages.ts
function nibblize(data) {
  const result = [];
  for (const byte of data) {
    result.push(byte >> 4 & 15);
    result.push(byte & 15);
  }
  return result;
}
function denibblize(nibbles) {
  const result = [];
  for (let i = 0; i < nibbles.length - 1; i += 2) {
    const msn = nibbles[i] & 15;
    const lsn = nibbles[i + 1] & 15;
    result.push(msn << 4 | lsn);
  }
  return result;
}
function calculateChecksum(address, data) {
  const sum = address.reduce((a, b) => a + b, 0) + data.reduce((a, b) => a + b, 0);
  const checksum = 128 - (sum & 127);
  return checksum === 128 ? 0 : checksum;
}
function encodeSize(size) {
  return [
    size >> 21 & 127,
    size >> 14 & 127,
    size >> 7 & 127,
    size & 127
  ];
}
function buildRQDMessage(deviceId, address, sizeNibbles) {
  if (address.length !== 4) {
    throw new Error(`Address must be 4 bytes, got ${address.length}`);
  }
  if ((address[3] & 1) !== 0) {
    throw new Error(`Address LSB must be EVEN, got 0x${address[3].toString(16)}`);
  }
  if ((sizeNibbles & 1) !== 0) {
    throw new Error(`Size LSB must be EVEN, got ${sizeNibbles}`);
  }
  const size = encodeSize(sizeNibbles);
  const checksum = calculateChecksum(address, size);
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.RQD,
    ...address,
    ...size,
    checksum,
    247
  ];
}
function buildWSDMessage(deviceId, address, sizeBytes) {
  if (address.length !== 4) {
    throw new Error(`Address must be 4 bytes, got ${address.length}`);
  }
  const size = encodeSize(sizeBytes);
  const checksum = calculateChecksum(address, size);
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.WSD,
    ...address,
    ...size,
    checksum,
    247
  ];
}
function buildDATMessage(deviceId, address, data) {
  if (address.length !== 4) {
    throw new Error(`Address must be 4 bytes, got ${address.length}`);
  }
  const checksum = calculateChecksum(address, data);
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.DAT,
    ...address,
    ...data,
    checksum,
    247
  ];
}
function buildDT1Message(deviceId, address, data) {
  if (address.length !== 4) {
    throw new Error(`Address must be 4 bytes, got ${address.length}`);
  }
  const checksum = calculateChecksum(address, data);
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.DT1,
    ...address,
    ...data,
    checksum,
    247
  ];
}
function buildACKMessage(deviceId) {
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.ACK,
    247
  ];
}
function buildEODMessage(deviceId) {
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.EOD,
    247
  ];
}
function buildRJCMessage(deviceId) {
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.RJC,
    247
  ];
}
function buildERRMessage(deviceId, errorCode) {
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.ERR,
    errorCode & 127,
    247
  ];
}

// src/devices/roland-s-series/s-series-params.ts
function parseKeyMode(value) {
  switch (value) {
    case 0:
      return "normal";
    case 1:
      return "v-sw";
    case 2:
      return "x-fade";
    case 3:
      return "v-mix";
    case 4:
      return "unison";
    default:
      return "normal";
  }
}
function encodeKeyMode(mode) {
  switch (mode) {
    case "normal":
      return 0;
    case "v-sw":
      return 1;
    case "x-fade":
      return 2;
    case "v-mix":
      return 3;
    case "unison":
      return 4;
  }
}
function parseAftertouchAssign(value) {
  switch (value) {
    case 0:
      return "modulation";
    case 1:
      return "volume";
    case 2:
      return "bend+";
    case 3:
      return "bend-";
    case 4:
      return "filter";
    default:
      return "modulation";
  }
}
function encodeAftertouchAssign(assign) {
  switch (assign) {
    case "modulation":
      return 0;
    case "volume":
      return 1;
    case "bend+":
      return 2;
    case "bend-":
      return 3;
    case "filter":
      return 4;
  }
}
function parseKeyAssign(value) {
  return value === 1 ? "fix" : "rotary";
}
function encodeKeyAssign(assign) {
  return assign === "fix" ? 1 : 0;
}
function parseLoopMode(value) {
  switch (value) {
    case 0:
      return "forward";
    case 1:
      return "alternating";
    case 2:
      return "one-shot";
    case 3:
      return "reverse";
    default:
      return "forward";
  }
}
function encodeLoopMode(mode) {
  switch (mode) {
    case "forward":
      return 0;
    case "alternating":
      return 1;
    case "one-shot":
      return 2;
    case "reverse":
      return 3;
  }
}
function parseEgPolarity(value) {
  return value === 1 ? "reverse" : "normal";
}
function encodeEgPolarity(polarity) {
  return polarity === "reverse" ? 1 : 0;
}
function parseLfoMode(value) {
  return value === 1 ? "one-shot" : "normal";
}
function encodeLfoMode(mode) {
  return mode === "one-shot" ? 1 : 0;
}
function parseLevelCurve(value) {
  const clamped = Math.max(0, Math.min(5, value));
  return clamped;
}
function parseSampleRate(value) {
  return value === 0 ? "30kHz" : "15kHz";
}
function encodeSampleRate(rate) {
  return rate === "30kHz" ? 0 : 1;
}
function parseName(data, offset, length = 8) {
  let name = "";
  for (let i = 0; i < length; i++) {
    const char = data[offset + i] & 127;
    if (char >= 32 && char <= 126) {
      name += String.fromCharCode(char);
    } else {
      name += " ";
    }
  }
  return name.trimEnd();
}
function encodeName(name, length = 8) {
  const result = [];
  const padded = name.padEnd(length, " ").substring(0, length);
  for (let i = 0; i < length; i++) {
    result.push(padded.charCodeAt(i) & 127);
  }
  return result;
}
function parse21BitAddress(data, offset) {
  return (data[offset] & 127) << 14 | (data[offset + 1] & 127) << 7 | data[offset + 2] & 127;
}
function encode21BitAddress(value) {
  return [
    value >> 14 & 127,
    value >> 7 & 127,
    value & 127
  ];
}
function parse24BitAddress(data, offset) {
  var _a, _b, _c;
  const b0 = (_a = data[offset]) != null ? _a : 0;
  const b1 = (_b = data[offset + 1]) != null ? _b : 0;
  const b2 = (_c = data[offset + 2]) != null ? _c : 0;
  return b0 << 16 | b1 << 8 | b2;
}
function encode24BitAddress(value) {
  return [
    value >> 16 & 255,
    value >> 8 & 255,
    value & 255
  ];
}
function parseSignedValue(value, center = 64) {
  return value - center;
}
function encodeSignedValue(value, center = 64) {
  return Math.max(0, Math.min(127, value + center));
}
function parseEnvelope(data, sustainOffset, endOffset, levelsStart) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  const levels = [
    (_a = data[levelsStart]) != null ? _a : 0,
    (_b = data[levelsStart + 2]) != null ? _b : 0,
    (_c = data[levelsStart + 4]) != null ? _c : 0,
    (_d = data[levelsStart + 6]) != null ? _d : 0,
    (_e = data[levelsStart + 8]) != null ? _e : 0,
    (_f = data[levelsStart + 10]) != null ? _f : 0,
    (_g = data[levelsStart + 12]) != null ? _g : 0,
    (_h = data[levelsStart + 14]) != null ? _h : 0
  ];
  const rates = [
    (_i = data[levelsStart + 1]) != null ? _i : 1,
    (_j = data[levelsStart + 3]) != null ? _j : 1,
    (_k = data[levelsStart + 5]) != null ? _k : 1,
    (_l = data[levelsStart + 7]) != null ? _l : 1,
    (_m = data[levelsStart + 9]) != null ? _m : 1,
    (_n = data[levelsStart + 11]) != null ? _n : 1,
    (_o = data[levelsStart + 13]) != null ? _o : 1,
    (_p = data[levelsStart + 15]) != null ? _p : 1
  ];
  const rawEndPoint = (_q = data[endOffset]) != null ? _q : 8;
  const endPoint = Math.max(1, Math.min(8, rawEndPoint));
  return {
    levels,
    rates,
    sustainPoint: (_r = data[sustainOffset]) != null ? _r : 0,
    endPoint
  };
}
function encodeEnvelope(envelope, sustainOffset, endOffset, levelsStart, output) {
  output[sustainOffset] = envelope.sustainPoint & 127;
  output[endOffset] = envelope.endPoint & 127;
  for (let i = 0; i < 8; i++) {
    output[levelsStart + i * 2] = envelope.levels[i] & 127;
    output[levelsStart + i * 2 + 1] = Math.max(1, envelope.rates[i]) & 127;
  }
}
function isValidDeviceId(id) {
  return id >= 0 && id <= 31;
}
function isValidMidiChannel(channel) {
  return channel >= 0 && channel <= 15;
}
function isValid7BitValue(value) {
  return value >= 0 && value <= 127;
}
function clamp7Bit(value) {
  return Math.max(0, Math.min(127, Math.round(value)));
}
function parseSeriesSystemParams(_data) {
  return {
    masterTune: 64,
    masterLevel: 127,
    midiChannel: 0,
    deviceId: 0,
    exclusiveEnabled: true,
    progChangeEnabled: true,
    ctrlChangeEnabled: true,
    benderEnabled: true,
    modWheelEnabled: true,
    aftertouchEnabled: true,
    holdPedalEnabled: true
  };
}
function encodeSeriesSystemParams(_params) {
  return [];
}
function parseSeriesPatchCommon(data, params) {
  const name = parseName(data, params.name.byteOffset, params.name.size);
  const toneLayer1 = [];
  for (let i = 0; i < params.toneLayer1.size; i++) {
    const value = data[params.toneLayer1.byteOffset + i];
    toneLayer1.push(value === 255 ? -1 : value);
  }
  const toneLayer2 = [];
  for (let i = 0; i < params.toneLayer2.size; i++) {
    toneLayer2.push(data[params.toneLayer2.byteOffset + i]);
  }
  const octaveShiftRaw = data[params.octaveShift.byteOffset];
  const octaveShift = octaveShiftRaw > 4 ? 0 : parseSignedValue(octaveShiftRaw, 2);
  const level = name.trim() ? data[params.level.byteOffset] : 127;
  return {
    name,
    benderRange: data[params.benderRange.byteOffset],
    aftertouchSens: data[params.aftertouchSens.byteOffset],
    keyMode: parseKeyMode(data[params.keyMode.byteOffset]),
    velocityThreshold: data[params.velocityThreshold.byteOffset],
    toneLayer1,
    toneLayer2,
    copySource: data[params.copySource.byteOffset],
    octaveShift,
    level,
    detune: parseSignedValue(data[params.detune.byteOffset]),
    velocityMixRatio: data[params.velocityMixRatio.byteOffset],
    aftertouchAssign: parseAftertouchAssign(data[params.aftertouchAssign.byteOffset]),
    keyAssign: parseKeyAssign(data[params.keyAssign.byteOffset]),
    outputAssign: data[params.outputAssign.byteOffset]
  };
}
function encodeSeriesPatchCommon(patchCommon, params) {
  const result = new Array(512).fill(0);
  const nameBytes = encodeName(patchCommon.name, params.name.size);
  for (let i = 0; i < params.name.size; i++) {
    result[params.name.byteOffset + i] = nameBytes[i];
  }
  result[params.benderRange.byteOffset] = patchCommon.benderRange;
  result[params.aftertouchSens.byteOffset] = patchCommon.aftertouchSens;
  result[params.keyMode.byteOffset] = encodeKeyMode(patchCommon.keyMode);
  result[params.velocityThreshold.byteOffset] = patchCommon.velocityThreshold;
  for (let i = 0; i < params.toneLayer1.size; i++) {
    const value = patchCommon.toneLayer1[i];
    result[params.toneLayer1.byteOffset + i] = value === -1 ? 255 : value;
  }
  for (let i = 0; i < params.toneLayer2.size; i++) {
    result[params.toneLayer2.byteOffset + i] = patchCommon.toneLayer2[i];
  }
  result[params.copySource.byteOffset] = patchCommon.copySource;
  result[params.octaveShift.byteOffset] = encodeSignedValue(patchCommon.octaveShift, 2);
  result[params.level.byteOffset] = patchCommon.level;
  result[params.detune.byteOffset] = encodeSignedValue(patchCommon.detune);
  result[params.velocityMixRatio.byteOffset] = patchCommon.velocityMixRatio;
  result[params.aftertouchAssign.byteOffset] = encodeAftertouchAssign(patchCommon.aftertouchAssign);
  result[params.keyAssign.byteOffset] = encodeKeyAssign(patchCommon.keyAssign);
  result[params.outputAssign.byteOffset] = patchCommon.outputAssign;
  return result;
}
function createEmptySeriesPatchCommon() {
  return {
    name: "",
    keyMode: "normal",
    benderRange: 2,
    aftertouchSens: 0,
    velocityThreshold: 64,
    velocityMixRatio: 64,
    level: 127,
    detune: 0,
    octaveShift: 0,
    aftertouchAssign: "modulation",
    keyAssign: "rotary",
    outputAssign: 0,
    toneLayer1: new Array(109).fill(-1),
    toneLayer2: new Array(109).fill(0),
    copySource: 0
  };
}
function parseSeriesTone(data, offsets) {
  const getByte = (offset, defaultVal = 0) => {
    var _a;
    return (_a = data[offset]) != null ? _a : defaultVal;
  };
  const wave = {
    bank: getByte(offsets.WAVE_BANK),
    segmentTop: getByte(offsets.WAVE_SEGMENT_TOP),
    segmentLength: getByte(offsets.WAVE_SEGMENT_LENGTH),
    startPoint: parse24BitAddress(data, offsets.START_POINT),
    endPoint: parse24BitAddress(data, offsets.END_POINT),
    loopPoint: parse24BitAddress(data, offsets.LOOP_POINT),
    loopLength: parse24BitAddress(data, offsets.LOOP_LENGTH)
  };
  const lfo = {
    rate: getByte(offsets.LFO_RATE),
    sync: getByte(offsets.LFO_SYNC) === 1,
    delay: getByte(offsets.LFO_DELAY),
    mode: parseLfoMode(getByte(offsets.LFO_MODE)),
    polarity: getByte(offsets.LFO_POLARITY) === 1,
    offset: getByte(offsets.LFO_OFFSET)
  };
  const tvaEnvelope = parseEnvelope(
    data,
    offsets.TVA_ENV_SUSTAIN_POINT,
    offsets.TVA_ENV_END_POINT,
    offsets.TVA_ENV_LEVEL_1
  );
  const tva = {
    lfoDepth: getByte(offsets.TVA_LFO_DEPTH),
    keyRate: getByte(offsets.TVA_KEY_RATE),
    level: getByte(offsets.TVA_LEVEL, 127),
    velRate: getByte(offsets.TVA_VEL_RATE),
    levelCurve: parseLevelCurve(getByte(offsets.TVA_LEVEL_CURVE)),
    envelope: tvaEnvelope
  };
  const tvfEnvelope = parseEnvelope(
    data,
    offsets.TVF_ENV_SUSTAIN_POINT,
    offsets.TVF_ENV_END_POINT,
    offsets.TVF_ENV_LEVEL_1
  );
  const tvf = {
    cutoff: getByte(offsets.TVF_CUTOFF, 127),
    resonance: getByte(offsets.TVF_RESONANCE),
    keyFollow: getByte(offsets.TVF_KEY_FOLLOW),
    lfoDepth: getByte(offsets.TVF_LFO_DEPTH),
    egDepth: getByte(offsets.TVF_EG_DEPTH),
    egPolarity: parseEgPolarity(getByte(offsets.TVF_EG_POLARITY)),
    levelCurve: parseLevelCurve(getByte(offsets.TVF_LEVEL_CURVE)),
    keyRateFollow: getByte(offsets.TVF_KEY_RATE_FOLLOW),
    velRateFollow: getByte(offsets.TVF_VEL_RATE_FOLLOW),
    enabled: getByte(offsets.TVF_SWITCH) === 1,
    envelope: tvfEnvelope
  };
  return {
    name: parseName(data, offsets.NAME, 8),
    outputAssign: getByte(offsets.OUTPUT_ASSIGN),
    sourceTone: getByte(offsets.SOURCE_TONE),
    origSubTone: getByte(offsets.ORIG_SUB_TONE),
    sampleRate: parseSampleRate(getByte(offsets.SAMPLING_FREQ)),
    originalKey: getByte(offsets.ORIG_KEY_NUMBER, 60),
    wave,
    loopMode: parseLoopMode(getByte(offsets.LOOP_MODE)),
    lfo,
    transpose: (() => {
      const raw = getByte(offsets.TRANSPOSE, 0);
      return raw > 127 ? raw - 256 : raw;
    })(),
    fineTune: getByte(offsets.FINE_TUNE, 0),
    tvf,
    tva,
    benderEnabled: getByte(offsets.BENDER_SWITCH) === 1,
    aftertouchEnabled: getByte(offsets.AFTERTOUCH_SWITCH) === 1,
    pitchFollow: getByte(offsets.PITCH_FOLLOW) === 1,
    recThreshold: getByte(offsets.REC_THRESHOLD),
    recPreTrigger: getByte(offsets.REC_PRE_TRIGGER),
    loopTune: (() => {
      const raw = getByte(offsets.LOOP_TUNE, 0);
      return raw > 127 ? raw - 256 : raw;
    })(),
    envZoom: getByte(offsets.ENV_ZOOM),
    copySource: getByte(offsets.COPY_SOURCE)
  };
}
function encodeSeriesTone(tone, offsets, toneBlockSize, limits) {
  const data = new Array(toneBlockSize).fill(0);
  const nameBytes = encodeName(tone.name, 8);
  for (let i = 0; i < 8; i++) {
    data[offsets.NAME + i] = nameBytes[i];
  }
  data[offsets.OUTPUT_ASSIGN] = tone.outputAssign & 127;
  data[offsets.SOURCE_TONE] = tone.sourceTone & limits.sourcetoneMask;
  data[offsets.ORIG_SUB_TONE] = tone.origSubTone & 1;
  data[offsets.SAMPLING_FREQ] = encodeSampleRate(tone.sampleRate);
  data[offsets.ORIG_KEY_NUMBER] = tone.originalKey & 127;
  data[offsets.WAVE_BANK] = tone.wave.bank & limits.waveBankMask;
  data[offsets.WAVE_SEGMENT_TOP] = tone.wave.segmentTop & 127;
  data[offsets.WAVE_SEGMENT_LENGTH] = tone.wave.segmentLength & 127;
  const startAddr = encode24BitAddress(tone.wave.startPoint);
  const endAddr = encode24BitAddress(tone.wave.endPoint);
  const loopAddr = encode24BitAddress(tone.wave.loopPoint);
  const loopLen = encode24BitAddress(tone.wave.loopLength);
  for (let i = 0; i < 3; i++) {
    data[offsets.START_POINT + i] = startAddr[i];
    data[offsets.END_POINT + i] = endAddr[i];
    data[offsets.LOOP_POINT + i] = loopAddr[i];
    data[offsets.LOOP_LENGTH + i] = loopLen[i];
  }
  data[offsets.LOOP_MODE] = encodeLoopMode(tone.loopMode);
  data[offsets.TVA_LFO_DEPTH] = tone.tva.lfoDepth & 127;
  data[offsets.LFO_RATE] = tone.lfo.rate & 127;
  data[offsets.LFO_SYNC] = tone.lfo.sync ? 1 : 0;
  data[offsets.LFO_DELAY] = tone.lfo.delay & 127;
  data[offsets.LFO_MODE] = encodeLfoMode(tone.lfo.mode);
  data[offsets.LFO_POLARITY] = tone.lfo.polarity ? 1 : 0;
  data[offsets.LFO_OFFSET] = tone.lfo.offset & 127;
  data[offsets.TRANSPOSE] = tone.transpose < 0 ? tone.transpose + 256 : tone.transpose;
  data[offsets.FINE_TUNE] = tone.fineTune & 127;
  data[offsets.TVF_CUTOFF] = tone.tvf.cutoff & 127;
  data[offsets.TVF_RESONANCE] = tone.tvf.resonance & 127;
  data[offsets.TVF_KEY_FOLLOW] = tone.tvf.keyFollow & 127;
  data[offsets.TVF_LFO_DEPTH] = tone.tvf.lfoDepth & 127;
  data[offsets.TVF_EG_DEPTH] = tone.tvf.egDepth & 127;
  data[offsets.TVF_EG_POLARITY] = encodeEgPolarity(tone.tvf.egPolarity);
  data[offsets.TVF_LEVEL_CURVE] = tone.tvf.levelCurve & 7;
  data[offsets.TVF_KEY_RATE_FOLLOW] = tone.tvf.keyRateFollow & 127;
  data[offsets.TVF_VEL_RATE_FOLLOW] = tone.tvf.velRateFollow & 127;
  data[offsets.TVF_SWITCH] = tone.tvf.enabled ? 1 : 0;
  data[offsets.BENDER_SWITCH] = tone.benderEnabled ? 1 : 0;
  encodeEnvelope(
    tone.tva.envelope,
    offsets.TVA_ENV_SUSTAIN_POINT,
    offsets.TVA_ENV_END_POINT,
    offsets.TVA_ENV_LEVEL_1,
    data
  );
  data[offsets.TVA_KEY_RATE] = tone.tva.keyRate & 127;
  data[offsets.TVA_LEVEL] = tone.tva.level & 127;
  data[offsets.TVA_VEL_RATE] = tone.tva.velRate & 127;
  data[offsets.TVA_LEVEL_CURVE] = tone.tva.levelCurve & 7;
  data[offsets.REC_THRESHOLD] = tone.recThreshold & 127;
  data[offsets.REC_PRE_TRIGGER] = tone.recPreTrigger & 3;
  data[offsets.COPY_SOURCE] = tone.copySource & limits.copySourceMask;
  data[offsets.LOOP_TUNE] = tone.loopTune < 0 ? tone.loopTune + 256 : tone.loopTune;
  data[offsets.PITCH_FOLLOW] = tone.pitchFollow ? 1 : 0;
  data[offsets.ENV_ZOOM] = tone.envZoom & 7;
  encodeEnvelope(
    tone.tvf.envelope,
    offsets.TVF_ENV_SUSTAIN_POINT,
    offsets.TVF_ENV_END_POINT,
    offsets.TVF_ENV_LEVEL_1,
    data
  );
  data[offsets.AFTERTOUCH_SWITCH] = tone.aftertouchEnabled ? 1 : 0;
  return data;
}

// src/devices/roland-s-series/s-series-wave-format.ts
function parseWav(buffer) {
  const view = new DataView(buffer);
  const riff = String.fromCharCode(view.getUint8(0), view.getUint8(1), view.getUint8(2), view.getUint8(3));
  if (riff !== "RIFF") {
    throw new Error("Invalid WAV file: missing RIFF header");
  }
  const wave = String.fromCharCode(view.getUint8(8), view.getUint8(9), view.getUint8(10), view.getUint8(11));
  if (wave !== "WAVE") {
    throw new Error("Invalid WAV file: missing WAVE format");
  }
  let offset = 12;
  let fmtChunk = null;
  let dataStart = 0;
  let dataSize = 0;
  while (offset < buffer.byteLength - 8) {
    const chunkId = String.fromCharCode(
      view.getUint8(offset),
      view.getUint8(offset + 1),
      view.getUint8(offset + 2),
      view.getUint8(offset + 3)
    );
    const chunkSize = view.getUint32(offset + 4, true);
    if (chunkId === "fmt ") {
      const audioFormat2 = view.getUint16(offset + 8, true);
      if (audioFormat2 !== 1 && audioFormat2 !== 3) {
        throw new Error(`Unsupported WAV format: ${audioFormat2} (only PCM and float supported)`);
      }
      fmtChunk = {
        audioFormat: audioFormat2,
        channels: view.getUint16(offset + 10, true),
        sampleRate: view.getUint32(offset + 12, true),
        bitsPerSample: view.getUint16(offset + 22, true)
      };
    } else if (chunkId === "data") {
      dataStart = offset + 8;
      dataSize = chunkSize;
    }
    offset += 8 + chunkSize;
    if (chunkSize % 2 !== 0) offset++;
  }
  if (!fmtChunk) {
    throw new Error("Invalid WAV file: missing fmt chunk");
  }
  if (dataStart === 0) {
    throw new Error("Invalid WAV file: missing data chunk");
  }
  const { audioFormat, channels, sampleRate, bitsPerSample } = fmtChunk;
  const bytesPerSample = bitsPerSample / 8;
  const frameCount = Math.floor(dataSize / (bytesPerSample * channels));
  const samples = new Int16Array(frameCount);
  for (let i = 0; i < frameCount; i++) {
    let sum = 0;
    for (let ch = 0; ch < channels; ch++) {
      const sampleOffset = dataStart + (i * channels + ch) * bytesPerSample;
      let sample;
      if (audioFormat === 3) {
        const floatSample = view.getFloat32(sampleOffset, true);
        sample = Math.round(Math.max(-1, Math.min(1, floatSample)) * 32767);
      } else {
        switch (bitsPerSample) {
          case 8:
            sample = (view.getUint8(sampleOffset) - 128) * 256;
            break;
          case 16:
            sample = view.getInt16(sampleOffset, true);
            break;
          case 24:
            sample = view.getUint8(sampleOffset) | view.getUint8(sampleOffset + 1) << 8 | view.getInt8(sampleOffset + 2) << 16;
            sample = sample >> 8;
            break;
          case 32:
            sample = view.getInt32(sampleOffset, true) >> 16;
            break;
          default:
            throw new Error(`Unsupported bit depth: ${bitsPerSample}`);
        }
      }
      sum += sample;
    }
    samples[i] = Math.round(sum / channels);
  }
  return { sampleRate, channels, bitsPerSample, samples };
}
function createWav(samples, sampleRate) {
  const numChannels = 1;
  const bitsPerSample = 16;
  const bytesPerSample = bitsPerSample / 8;
  const blockAlign = numChannels * bytesPerSample;
  const byteRate = sampleRate * blockAlign;
  const dataSize = samples.length * bytesPerSample;
  const headerSize = 44;
  const fileSize = headerSize + dataSize;
  const buffer = new ArrayBuffer(fileSize);
  const view = new DataView(buffer);
  view.setUint8(0, "R".charCodeAt(0));
  view.setUint8(1, "I".charCodeAt(0));
  view.setUint8(2, "F".charCodeAt(0));
  view.setUint8(3, "F".charCodeAt(0));
  view.setUint32(4, fileSize - 8, true);
  view.setUint8(8, "W".charCodeAt(0));
  view.setUint8(9, "A".charCodeAt(0));
  view.setUint8(10, "V".charCodeAt(0));
  view.setUint8(11, "E".charCodeAt(0));
  view.setUint8(12, "f".charCodeAt(0));
  view.setUint8(13, "m".charCodeAt(0));
  view.setUint8(14, "t".charCodeAt(0));
  view.setUint8(15, " ".charCodeAt(0));
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, numChannels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, byteRate, true);
  view.setUint16(32, blockAlign, true);
  view.setUint16(34, bitsPerSample, true);
  view.setUint8(36, "d".charCodeAt(0));
  view.setUint8(37, "a".charCodeAt(0));
  view.setUint8(38, "t".charCodeAt(0));
  view.setUint8(39, "a".charCodeAt(0));
  view.setUint32(40, dataSize, true);
  for (let i = 0; i < samples.length; i++) {
    view.setInt16(44 + i * 2, samples[i], true);
  }
  return buffer;
}
function resample(samples, fromRate, toRate) {
  if (fromRate === toRate) {
    return samples;
  }
  const ratio = fromRate / toRate;
  const newLength = Math.floor(samples.length / ratio);
  const result = new Int16Array(newLength);
  for (let i = 0; i < newLength; i++) {
    const srcIndex = i * ratio;
    const srcIndexFloor = Math.floor(srcIndex);
    const srcIndexCeil = Math.min(srcIndexFloor + 1, samples.length - 1);
    const fraction = srcIndex - srcIndexFloor;
    result[i] = Math.round(
      samples[srcIndexFloor] * (1 - fraction) + samples[srcIndexCeil] * fraction
    );
  }
  return result;
}
function wavToSeries(wav, targetSampleRate) {
  const resampled = resample(wav.samples, wav.sampleRate, targetSampleRate);
  const sampleCount = resampled.length;
  const data = new Uint8Array(sampleCount * 2);
  for (let i = 0; i < sampleCount; i++) {
    const sample16 = resampled[i];
    let sample12 = sample16 >> 4;
    sample12 = Math.max(-2048, Math.min(2047, sample12));
    const unsigned12 = sample12 < 0 ? sample12 + 4096 : sample12;
    data[i * 2] = unsigned12 >> 5 & 127;
    data[i * 2 + 1] = unsigned12 << 2 & 124;
  }
  return { data, sampleRate: targetSampleRate, sampleCount };
}
function seriesToWav(seriesData, _sampleRate) {
  const sampleCount = Math.floor(seriesData.length / 2);
  const samples = new Int16Array(sampleCount);
  for (let i = 0; i < sampleCount; i++) {
    const byte0 = seriesData[i * 2];
    const byte1 = seriesData[i * 2 + 1];
    const sample12bit = byte0 << 5 | byte1 >> 2;
    let signedSample;
    if (sample12bit & 2048) {
      signedSample = sample12bit - 4096;
    } else {
      signedSample = sample12bit;
    }
    samples[i] = signedSample << 4;
  }
  return samples;
}
function calculateSegmentsNeeded(sampleCount) {
  const SAMPLES_PER_SEGMENT = 12e3;
  return Math.ceil(sampleCount / SAMPLES_PER_SEGMENT);
}
function validateWaveDataFits(sampleCount, segmentLength) {
  const SAMPLES_PER_SEGMENT = 12e3;
  const availableSamples = segmentLength * SAMPLES_PER_SEGMENT;
  const neededSegments = calculateSegmentsNeeded(sampleCount);
  return {
    fits: sampleCount <= availableSamples,
    neededSegments,
    availableSamples
  };
}
function prepareWavForSSeries(wavBytes, targetSampleRate, options) {
  const wavData = parseWav(wavBytes);
  const source = {
    sampleRate: wavData.sampleRate,
    bitsPerSample: wavData.bitsPerSample,
    channels: wavData.channels,
    sampleCount: wavData.samples.length,
    duration: wavData.samples.length / wavData.sampleRate
  };
  const seriesData = wavToSeries(wavData, targetSampleRate);
  const segmentLength = calculateSegmentsNeeded(seriesData.sampleCount);
  if (options == null ? void 0 : options.enableDiagnostics) {
    const expectedOutputSamples = Math.floor(wavData.samples.length * (targetSampleRate / wavData.sampleRate));
    const actualRatio = wavData.samples.length / seriesData.sampleCount;
    const expectedRatio = wavData.sampleRate / targetSampleRate;
    console.log(`[prepareWavForSSeries] ========================================`);
    console.log(`[prepareWavForSSeries] SOURCE WAV:`);
    console.log(`[prepareWavForSSeries]   Sample rate: ${wavData.sampleRate} Hz`);
    console.log(`[prepareWavForSSeries]   Bit depth: ${wavData.bitsPerSample}-bit`);
    console.log(`[prepareWavForSSeries]   Channels: ${wavData.channels}`);
    console.log(`[prepareWavForSSeries]   Sample count: ${wavData.samples.length}`);
    console.log(`[prepareWavForSSeries]   Duration: ${source.duration.toFixed(3)}s`);
    console.log(`[prepareWavForSSeries] TARGET:`);
    console.log(`[prepareWavForSSeries]   Sample rate: ${targetSampleRate} Hz`);
    console.log(`[prepareWavForSSeries]   Expected samples: ${expectedOutputSamples}`);
    console.log(`[prepareWavForSSeries] RESULT:`);
    console.log(`[prepareWavForSSeries]   Output samples: ${seriesData.sampleCount}`);
    console.log(`[prepareWavForSSeries]   Output bytes: ${seriesData.data.length}`);
    console.log(`[prepareWavForSSeries]   Segments: ${segmentLength}`);
    console.log(`[prepareWavForSSeries]   Output duration: ${(seriesData.sampleCount / targetSampleRate).toFixed(3)}s`);
    if (Math.abs(actualRatio - expectedRatio) > 0.01) {
      console.error(`[prepareWavForSSeries] WARNING: RESAMPLING MISMATCH!`);
      console.error(`[prepareWavForSSeries]   Actual ratio: ${actualRatio.toFixed(4)}`);
      console.error(`[prepareWavForSSeries]   Expected ratio: ${expectedRatio.toFixed(4)}`);
    } else {
      console.log(`[prepareWavForSSeries] Resampling verified: ${actualRatio.toFixed(4)}x`);
    }
  }
  return {
    data: seriesData.data,
    sampleCount: seriesData.sampleCount,
    segmentLength,
    sampleRate: targetSampleRate,
    source
  };
}
function clampWaveParams(wave, sampleCount) {
  const maxEndPoint = Math.max(0, sampleCount - 1);
  const endPoint = wave.endPoint > 0 ? Math.min(wave.endPoint, maxEndPoint) : maxEndPoint;
  const startPoint = Math.min(Math.max(0, wave.startPoint), endPoint);
  const loopPoint = Math.min(Math.max(0, wave.loopPoint), endPoint);
  const loopLength = Math.max(0, endPoint - loopPoint);
  return __spreadProps(__spreadValues({}, wave), {
    startPoint,
    endPoint,
    loopPoint,
    loopLength
  });
}

// src/devices/roland-s-series/s-series-client.ts
import { withRetry } from "@audiocontrol/midi-core";
function createSSeriesClient(config, midiAdapter, parsers, addressBuilders, patchParamConfig, options = {}) {
  var _a, _b, _c;
  const deviceId = (_a = options.deviceId) != null ? _a : DEFAULT_DEVICE_ID;
  const timeoutMs = (_b = options.timeoutMs) != null ? _b : TIMING.ACK_TIMEOUT_MS;
  const writeFlushDelayMs = (_c = options.writeFlushDelayMs) != null ? _c : 150;
  let connected = false;
  const MULTI_CHANNELS_ADDRESS = [0, 1, 0, 34];
  const MULTI_PATCHES_ADDRESS = [0, 1, 0, 50];
  const MULTI_OUTPUTS_ADDRESS = [0, 1, 0, 66];
  const MULTI_LEVELS_ADDRESS = [0, 1, 0, 86];
  const MULTI_PART_COUNT = 8;
  let patchCache = new Array(config.patchCount).fill(void 0);
  let toneCache = new Array(config.toneCount).fill(void 0);
  let requestQueue = Promise.resolve();
  function serialize(fn) {
    const result = requestQueue.then(fn, fn);
    requestQueue = result.catch(() => {
    });
    return result;
  }
  const writeBuffer = /* @__PURE__ */ new Map();
  let flushTimer = null;
  let flushPromise = null;
  function addressKey(address) {
    return address.join(",");
  }
  function flushWriteBuffer() {
    return __async(this, null, function* () {
      if (writeBuffer.size === 0) return;
      const pending = Array.from(writeBuffer.values());
      writeBuffer.clear();
      flushTimer = null;
      for (const { address, data } of pending) {
        yield serialize(() => __async(null, null, function* () {
          yield sendData(address, data);
        }));
      }
    });
  }
  function bufferWrite(address, data) {
    if (writeFlushDelayMs === 0) {
      return serialize(() => __async(null, null, function* () {
        yield sendData(address, data);
      }));
    }
    const key = addressKey(address);
    writeBuffer.set(key, { address, data });
    if (!flushTimer) {
      flushPromise = new Promise((resolve, reject) => {
        flushTimer = setTimeout(() => {
          flushWriteBuffer().then(resolve).catch(reject);
        }, writeFlushDelayMs);
      });
    }
    return flushPromise;
  }
  function sendAndReceive(message, acceptCommands) {
    return new Promise((resolve, reject) => {
      let timeoutId = setTimeout(onTimeout, timeoutMs);
      function onTimeout() {
        midiAdapter.removeSysExListener(listener);
        reject(new Error(`${config.deviceName} response timeout`));
      }
      function resetTimeout() {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(onTimeout, timeoutMs);
      }
      function listener(response) {
        if (response.length >= 5 && response[1] === ROLAND_ID && response[2] === deviceId && response[3] === S_SERIES_MODEL_ID) {
          const cmd = response[4];
          if (cmd === S_SERIES_COMMANDS.RJC) {
            console.warn(`[${config.deviceName}] Ignoring stale RJC in sendAndReceive`);
            resetTimeout();
            return;
          }
          if (acceptCommands && !acceptCommands.includes(cmd)) {
            console.warn(`[${config.deviceName}] Ignoring stale 0x${cmd.toString(16)} (expected ${acceptCommands.map((c) => "0x" + c.toString(16)).join("/")})`);
            resetTimeout();
            return;
          }
          clearTimeout(timeoutId);
          midiAdapter.removeSysExListener(listener);
          resolve(response);
        }
      }
      midiAdapter.onSysEx(listener);
      midiAdapter.send(message);
    });
  }
  function requestDataWithAddress(address, sizeInBytes) {
    return __async(this, null, function* () {
      if (address.length !== 4) {
        throw new Error("Address must be 4 bytes");
      }
      if (address[3] & 1) {
        throw new Error(
          `Address LSB must be even (got 0x${address[3].toString(16)})`
        );
      }
      const sizeInNibbles = sizeInBytes * 2;
      const size = [
        sizeInNibbles >> 21 & 127,
        sizeInNibbles >> 14 & 127,
        sizeInNibbles >> 7 & 127,
        sizeInNibbles & 127
      ];
      const cs = calculateChecksum(address, size);
      const message = [
        240,
        ROLAND_ID,
        deviceId,
        S_SERIES_MODEL_ID,
        S_SERIES_COMMANDS.RQD,
        ...address,
        ...size,
        cs,
        247
      ];
      return new Promise((resolve, reject) => {
        const allNibbles = [];
        let timeoutId;
        let sendTime = 0;
        function resetTimeout() {
          if (timeoutId) clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            midiAdapter.removeSysExListener(listener);
            if (allNibbles.length > 0) {
              resolve(denibblize(allNibbles));
            } else {
              reject(new Error("RQD response timeout - no data received"));
            }
          }, timeoutMs * 2);
        }
        function listener(response) {
          if (response.length >= 5 && response[1] === ROLAND_ID && response[2] === deviceId && response[3] === S_SERIES_MODEL_ID) {
            const command = response[4];
            if (command === S_SERIES_COMMANDS.DAT) {
              resetTimeout();
              const dataStart = 5 + 4;
              const dataEnd = response.length - 2;
              const nibbleData = response.slice(dataStart, dataEnd);
              allNibbles.push(...nibbleData);
              const ack = [
                240,
                ROLAND_ID,
                deviceId,
                S_SERIES_MODEL_ID,
                S_SERIES_COMMANDS.ACK,
                247
              ];
              midiAdapter.send(ack);
            } else if (command === S_SERIES_COMMANDS.EOD) {
              clearTimeout(timeoutId);
              midiAdapter.removeSysExListener(listener);
              const ack = [
                240,
                ROLAND_ID,
                deviceId,
                S_SERIES_MODEL_ID,
                S_SERIES_COMMANDS.ACK,
                247
              ];
              midiAdapter.send(ack);
              resolve(denibblize(allNibbles));
            } else if (command === S_SERIES_COMMANDS.RJC) {
              const sinceSend = Date.now() - sendTime;
              const rjcHex = response.map((b) => b.toString(16).padStart(2, "0")).join(" ");
              const addrHex = address.map((b) => b.toString(16).padStart(2, "0")).join(" ");
              console.warn(
                `[${config.deviceName}] Ignoring stale RJC during RQD: addr=[${addrHex}] time-since-send=${sinceSend}ms rjc-bytes=[${rjcHex}]`
              );
              resetTimeout();
              return;
            } else if (command === S_SERIES_COMMANDS.ERR) {
              clearTimeout(timeoutId);
              midiAdapter.removeSysExListener(listener);
              reject(new Error("Device reported error"));
            }
          }
        }
        resetTimeout();
        midiAdapter.onSysEx(listener);
        midiAdapter.send(message);
        sendTime = Date.now();
      });
    });
  }
  function sendDataAttempt(address, data) {
    return __async(this, null, function* () {
      const nibbled = nibblize(data);
      const sizeInNibbles = nibbled.length;
      const size = [
        sizeInNibbles >> 21 & 127,
        sizeInNibbles >> 14 & 127,
        sizeInNibbles >> 7 & 127,
        sizeInNibbles & 127
      ];
      const wsdChecksum = calculateChecksum(address, size);
      const wsd = [
        240,
        ROLAND_ID,
        deviceId,
        S_SERIES_MODEL_ID,
        S_SERIES_COMMANDS.WSD,
        ...address,
        ...size,
        wsdChecksum,
        247
      ];
      const wsdResponse = yield sendAndReceive(wsd, [S_SERIES_COMMANDS.ACK, S_SERIES_COMMANDS.ERR]);
      if (wsdResponse[4] !== S_SERIES_COMMANDS.ACK) {
        throw new Error(`WSD rejected: got ${wsdResponse[4].toString(16)}`);
      }
      const NIBBLES_PER_PACKET = 128;
      for (let offset = 0; offset < nibbled.length; offset += NIBBLES_PER_PACKET) {
        const chunk = nibbled.slice(offset, offset + NIBBLES_PER_PACKET);
        const chunkIndex = offset / NIBBLES_PER_PACKET;
        const linearAddr2 = address[2] + chunkIndex;
        const packetAddress = [
          address[0],
          address[1] + Math.floor(linearAddr2 / 128) & 127,
          linearAddr2 & 127,
          address[3]
        ];
        const datChecksum = calculateChecksum(packetAddress, chunk);
        const dat = [
          240,
          ROLAND_ID,
          deviceId,
          S_SERIES_MODEL_ID,
          S_SERIES_COMMANDS.DAT,
          ...packetAddress,
          ...chunk,
          datChecksum,
          247
        ];
        const datResponse = yield sendAndReceive(dat, [S_SERIES_COMMANDS.ACK, S_SERIES_COMMANDS.ERR]);
        if (datResponse[4] !== S_SERIES_COMMANDS.ACK) {
          throw new Error(`DAT rejected: got ${datResponse[4].toString(16)}`);
        }
      }
      const eod = [
        240,
        ROLAND_ID,
        deviceId,
        S_SERIES_MODEL_ID,
        S_SERIES_COMMANDS.EOD,
        247
      ];
      const eodResponse = yield sendAndReceive(eod, [S_SERIES_COMMANDS.ACK, S_SERIES_COMMANDS.ERR]);
      if (eodResponse[4] !== S_SERIES_COMMANDS.ACK) {
        throw new Error(`EOD rejected: got ${eodResponse[4].toString(16)}`);
      }
    });
  }
  const wsdRetryOptions = {
    maxRetries: 3,
    initialDelayMs: 100,
    maxDelayMs: 2e3,
    multiplier: 2,
    jitter: 0.3,
    isRetryable: (error) => {
      if (error instanceof Error) {
        return error.message.includes("timeout") || error.message.includes("rejected");
      }
      return false;
    },
    onRetry: (attempt, error, delayMs) => {
      console.log(`[${config.deviceName}] WSD retry ${attempt} after ${delayMs}ms: ${error}`);
    }
  };
  function sendData(address, data) {
    return __async(this, null, function* () {
      return withRetry(() => sendDataAttempt(address, data), wsdRetryOptions);
    });
  }
  function sendWaveDataInternal(address, waveData, onProgress) {
    return __async(this, null, function* () {
      const totalBytes = waveData.length;
      const size = [
        totalBytes >> 21 & 127,
        totalBytes >> 14 & 127,
        totalBytes >> 7 & 127,
        totalBytes & 127
      ];
      const wsdChecksum = calculateChecksum(address, size);
      const wsd = [
        240,
        ROLAND_ID,
        deviceId,
        S_SERIES_MODEL_ID,
        S_SERIES_COMMANDS.WSD,
        ...address,
        ...size,
        wsdChecksum,
        247
      ];
      const wsdResponse = yield sendAndReceive(wsd, [S_SERIES_COMMANDS.ACK, S_SERIES_COMMANDS.ERR]);
      if (wsdResponse[4] !== S_SERIES_COMMANDS.ACK) {
        throw new Error(`Wave WSD rejected: got ${wsdResponse[4].toString(16)}`);
      }
      const WAVE_PACKET_SIZE = 128;
      let bytesSent = 0;
      for (let offset = 0; offset < totalBytes; offset += WAVE_PACKET_SIZE) {
        const end = Math.min(offset + WAVE_PACKET_SIZE, totalBytes);
        const chunk = Array.from(waveData.slice(offset, end));
        const chunkIndex = offset / WAVE_PACKET_SIZE;
        const linearAddr2 = address[2] + chunkIndex;
        const packetAddress = [
          address[0],
          address[1] + Math.floor(linearAddr2 / 128) & 127,
          linearAddr2 & 127,
          address[3]
        ];
        const datChecksum = calculateChecksum(packetAddress, chunk);
        const dat = [
          240,
          ROLAND_ID,
          deviceId,
          S_SERIES_MODEL_ID,
          S_SERIES_COMMANDS.DAT,
          ...packetAddress,
          ...chunk,
          datChecksum,
          247
        ];
        const datResponse = yield sendAndReceive(dat, [S_SERIES_COMMANDS.ACK, S_SERIES_COMMANDS.ERR]);
        if (datResponse[4] !== S_SERIES_COMMANDS.ACK) {
          throw new Error(`Wave DAT rejected at offset ${offset}`);
        }
        bytesSent = end;
        onProgress == null ? void 0 : onProgress(bytesSent, totalBytes);
      }
      const eod = [
        240,
        ROLAND_ID,
        deviceId,
        S_SERIES_MODEL_ID,
        S_SERIES_COMMANDS.EOD,
        247
      ];
      const eodResponse = yield sendAndReceive(eod, [S_SERIES_COMMANDS.ACK, S_SERIES_COMMANDS.ERR]);
      if (eodResponse[4] !== S_SERIES_COMMANDS.ACK) {
        throw new Error(`Wave EOD rejected`);
      }
    });
  }
  return {
    getConfig() {
      return config;
    },
    connect() {
      return __async(this, null, function* () {
        connected = true;
        return true;
      });
    },
    disconnect() {
      connected = false;
    },
    isConnected() {
      return connected;
    },
    getDeviceId() {
      return deviceId;
    },
    // === Patch Operations ===
    requestPatchData(patchIndex) {
      return __async(this, null, function* () {
        return serialize(() => __async(null, null, function* () {
          const address = addressBuilders.buildPatchAddress(patchIndex);
          const data = yield requestDataWithAddress(address, config.patchBlockSize);
          const common = parsers.parsePatchCommon(data);
          const patch = parsers.createPatch(common);
          patchCache[patchIndex] = patch;
          return patch;
        }));
      });
    },
    sendPatchData(patchIndex, patch) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchAddress(patchIndex);
        const data = parsers.encodePatchCommon(patch);
        yield bufferWrite(address, data);
        const fullPatch = parsers.createPatch(patch);
        patchCache[patchIndex] = fullPatch;
      });
    },
    loadPatchRange(startIndex, count, onProgress, onPatchLoaded, forceReload) {
      return __async(this, null, function* () {
        const patches = [];
        for (let i = 0; i < count; i++) {
          const index = startIndex + i;
          if (index >= config.patchCount) break;
          if (!forceReload && patchCache[index]) {
            patches.push(patchCache[index]);
            onProgress == null ? void 0 : onProgress(i + 1, count);
            onPatchLoaded == null ? void 0 : onPatchLoaded(index, patchCache[index]);
            continue;
          }
          const patch = yield this.requestPatchData(index);
          if (patch) {
            patches.push(patch);
            onPatchLoaded == null ? void 0 : onPatchLoaded(index, patch);
          }
          onProgress == null ? void 0 : onProgress(i + 1, count);
        }
        return patches;
      });
    },
    getLoadedPatches() {
      return [...patchCache];
    },
    invalidatePatchCache() {
      patchCache = new Array(config.patchCount).fill(void 0);
    },
    // === Tone Operations ===
    requestToneData(toneIndex) {
      return __async(this, null, function* () {
        return serialize(() => __async(null, null, function* () {
          const address = addressBuilders.buildToneAddress(toneIndex);
          const data = yield requestDataWithAddress(address, config.toneBlockSize);
          const tone = parsers.parseTone(data);
          toneCache[toneIndex] = tone;
          return tone;
        }));
      });
    },
    sendToneData(toneIndex, tone) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildToneAddress(toneIndex);
        const data = parsers.encodeTone(tone);
        yield bufferWrite(address, data);
        toneCache[toneIndex] = tone;
      });
    },
    loadToneRange(startIndex, count, onProgress, onToneLoaded, forceReload) {
      return __async(this, null, function* () {
        const tones = [];
        for (let i = 0; i < count; i++) {
          const index = startIndex + i;
          if (index >= config.toneCount) break;
          if (!forceReload && toneCache[index]) {
            tones.push(toneCache[index]);
            onProgress == null ? void 0 : onProgress(i + 1, count);
            onToneLoaded == null ? void 0 : onToneLoaded(index, toneCache[index]);
            continue;
          }
          const tone = yield this.requestToneData(index);
          if (tone) {
            tones.push(tone);
            onToneLoaded == null ? void 0 : onToneLoaded(index, tone);
          }
          onProgress == null ? void 0 : onProgress(i + 1, count);
        }
        return tones;
      });
    },
    getLoadedTones() {
      return [...toneCache];
    },
    invalidateToneCache() {
      toneCache = new Array(config.toneCount).fill(void 0);
    },
    // === Wave Data Operations ===
    requestWaveData(toneIndex, onProgress) {
      return __async(this, null, function* () {
        return serialize(() => __async(this, null, function* () {
          var _a2, _b2;
          const tone = (_a2 = toneCache[toneIndex]) != null ? _a2 : yield this.requestToneData(toneIndex);
          if (!tone) {
            throw new Error(`Tone ${toneIndex} not found`);
          }
          const wave = parsers.getToneWave(tone);
          const address = addressBuilders.buildWaveDataAddress(wave.bank, wave.segmentTop);
          const SAMPLES_PER_SEGMENT = 12e3;
          const BYTES_PER_SAMPLE = 2;
          const totalBytes = wave.segmentLength * SAMPLES_PER_SEGMENT * BYTES_PER_SAMPLE;
          const allBytes = [];
          const size = [
            totalBytes >> 21 & 127,
            totalBytes >> 14 & 127,
            totalBytes >> 7 & 127,
            totalBytes & 127
          ];
          const cs = calculateChecksum(address, size);
          const rqd = [
            240,
            ROLAND_ID,
            deviceId,
            S_SERIES_MODEL_ID,
            S_SERIES_COMMANDS.RQD,
            ...address,
            ...size,
            cs,
            247
          ];
          yield new Promise((resolve, reject) => {
            let timeoutId;
            function resetTimeout() {
              if (timeoutId) clearTimeout(timeoutId);
              timeoutId = setTimeout(() => {
                midiAdapter.removeSysExListener(listener);
                if (allBytes.length > 0) {
                  resolve();
                } else {
                  reject(new Error("Wave data timeout"));
                }
              }, timeoutMs * 4);
            }
            function listener(response) {
              if (response.length >= 5 && response[1] === ROLAND_ID && response[2] === deviceId && response[3] === S_SERIES_MODEL_ID) {
                const command = response[4];
                if (command === S_SERIES_COMMANDS.DAT) {
                  resetTimeout();
                  const dataStart = 5 + 4;
                  const dataEnd = response.length - 2;
                  allBytes.push(...response.slice(dataStart, dataEnd));
                  onProgress == null ? void 0 : onProgress(allBytes.length, totalBytes);
                  const ack = [
                    240,
                    ROLAND_ID,
                    deviceId,
                    S_SERIES_MODEL_ID,
                    S_SERIES_COMMANDS.ACK,
                    247
                  ];
                  midiAdapter.send(ack);
                } else if (command === S_SERIES_COMMANDS.EOD) {
                  clearTimeout(timeoutId);
                  midiAdapter.removeSysExListener(listener);
                  const ack = [
                    240,
                    ROLAND_ID,
                    deviceId,
                    S_SERIES_MODEL_ID,
                    S_SERIES_COMMANDS.ACK,
                    247
                  ];
                  midiAdapter.send(ack);
                  resolve();
                } else if (command === S_SERIES_COMMANDS.RJC || command === S_SERIES_COMMANDS.ERR) {
                  clearTimeout(timeoutId);
                  midiAdapter.removeSysExListener(listener);
                  reject(new Error("Wave data request rejected"));
                }
              }
            }
            resetTimeout();
            midiAdapter.onSysEx(listener);
            midiAdapter.send(rqd);
          });
          const toneData = toneCache[toneIndex];
          const toneWave = parsers.getToneWave(toneData);
          return {
            data: new Uint8Array(allBytes),
            sampleRate: toneData.sampleRate === "15kHz" ? 15e3 : 3e4,
            startPoint: toneWave.startPoint,
            endPoint: toneWave.endPoint,
            loopPoint: toneWave.loopPoint,
            loopMode: (_b2 = toneData.loopMode) != null ? _b2 : "one-shot"
          };
        }));
      });
    },
    sendWaveData(input, onProgress) {
      return __async(this, null, function* () {
        return serialize(() => __async(null, null, function* () {
          const address = addressBuilders.buildWaveDataAddress(input.waveBank, input.segmentTop);
          yield sendWaveDataInternal(address, input.data, onProgress);
        }));
      });
    },
    importTone(input, onProgress) {
      return __async(this, null, function* () {
        return serialize(() => __async(null, null, function* () {
          var _a2, _b2, _c2, _d2, _e;
          const { toneIndex, waveData, waveBank, segmentTop, segmentLength } = input;
          const sampleCount = Math.floor(waveData.length / 2);
          let tone;
          if (input.tone) {
            const originalWave = parsers.getToneWave(input.tone);
            const clampedWave = clampWaveParams(
              __spreadProps(__spreadValues({}, originalWave), {
                bank: waveBank,
                segmentTop,
                segmentLength
              }),
              sampleCount
            );
            tone = parsers.setToneWave(input.tone, clampedWave);
          } else {
            tone = parsers.createTone({
              name: (_a2 = input.name) != null ? _a2 : "UNNAMED",
              sampleRate: (_b2 = input.sampleRate) != null ? _b2 : "30kHz",
              waveBank,
              segmentTop,
              segmentLength,
              sampleCount,
              loopMode: (_c2 = input.loopMode) != null ? _c2 : "one-shot",
              loopPoint: (_d2 = input.loopPoint) != null ? _d2 : 0,
              originalKey: (_e = input.originalKey) != null ? _e : 60
            });
          }
          const toneAddress = addressBuilders.buildToneAddress(toneIndex);
          const toneData = parsers.encodeTone(tone);
          yield sendData(toneAddress, toneData);
          toneCache[toneIndex] = tone;
          const waveAddress = addressBuilders.buildWaveDataAddress(waveBank, segmentTop);
          yield sendWaveDataInternal(waveAddress, waveData, onProgress);
          yield new Promise((resolve) => setTimeout(resolve, 500));
          yield sendData(toneAddress, toneData);
        }));
      });
    },
    // === Multi Mode Configuration ===
    requestFunctionParameters() {
      return __async(this, null, function* () {
        return serialize(() => __async(null, null, function* () {
          var _a2, _b2, _c2, _d2;
          try {
            const channelData = yield requestDataWithAddress(
              MULTI_CHANNELS_ADDRESS,
              MULTI_PART_COUNT
            );
            const patchData = yield requestDataWithAddress(
              MULTI_PATCHES_ADDRESS,
              MULTI_PART_COUNT
            );
            let outputData;
            try {
              outputData = yield requestDataWithAddress(
                MULTI_OUTPUTS_ADDRESS,
                MULTI_PART_COUNT
              );
            } catch (e) {
              outputData = [1, 1, 1, 1, 1, 1, 1, 1];
            }
            const levelData = yield requestDataWithAddress(
              MULTI_LEVELS_ADDRESS,
              MULTI_PART_COUNT
            );
            const parts = [];
            for (let i = 0; i < MULTI_PART_COUNT; i++) {
              parts.push({
                channel: (_a2 = channelData[i]) != null ? _a2 : 0,
                patchIndex: (_b2 = patchData[i]) != null ? _b2 : 0,
                output: (_c2 = outputData[i]) != null ? _c2 : 1,
                level: (_d2 = levelData[i]) != null ? _d2 : 127
              });
            }
            return parts;
          } catch (e) {
            return Array.from({ length: MULTI_PART_COUNT }, (_, i) => ({
              channel: i,
              patchIndex: 0,
              output: 1,
              level: 127
            }));
          }
        }));
      });
    },
    /**
     * Set MIDI receive channel for a multi mode part.
     * Uses WSD/DAT/EOD protocol (DT1 does not work for function parameters).
     */
    setMultiChannel(part, channel) {
      return __async(this, null, function* () {
        if (part < 0 || part > 7) {
          throw new Error(`Invalid part number: ${part} (must be 0-7)`);
        }
        if (channel < 0 || channel > 15) {
          throw new Error(`Invalid channel: ${channel} (must be 0-15)`);
        }
        return serialize(() => __async(null, null, function* () {
          const allChannelData = yield requestDataWithAddress(
            MULTI_CHANNELS_ADDRESS,
            MULTI_PART_COUNT
          );
          const newChannelData = [...allChannelData];
          newChannelData[part] = channel;
          yield sendData(MULTI_CHANNELS_ADDRESS, newChannelData);
        }));
      });
    },
    /**
     * Set patch assignment for a multi mode part.
     * Uses WSD/DAT/EOD protocol (DT1 does not work for function parameters).
     */
    setMultiPatch(part, patchIndex) {
      return __async(this, null, function* () {
        if (part < 0 || part > 7) {
          throw new Error(`Invalid part number: ${part} (must be 0-7)`);
        }
        const value = patchIndex === null ? 127 : patchIndex;
        if (patchIndex !== null && (patchIndex < 0 || patchIndex > 63)) {
          throw new Error(`Invalid patch index: ${patchIndex} (must be 0-63 or null)`);
        }
        return serialize(() => __async(null, null, function* () {
          const allPatchData = yield requestDataWithAddress(
            MULTI_PATCHES_ADDRESS,
            MULTI_PART_COUNT
          );
          const newPatchData = [...allPatchData];
          newPatchData[part] = value;
          yield sendData(MULTI_PATCHES_ADDRESS, newPatchData);
        }));
      });
    },
    /**
     * Set output assignment for a multi mode part.
     * Uses WSD/DAT/EOD protocol (DT1 does not work for function parameters).
     */
    setMultiOutput(part, output) {
      return __async(this, null, function* () {
        if (part < 0 || part > 7) {
          throw new Error(`Invalid part number: ${part} (must be 0-7)`);
        }
        if (output < 0 || output > 8) {
          throw new Error(`Invalid output: ${output} (must be 0-8)`);
        }
        return serialize(() => __async(null, null, function* () {
          let allOutputData;
          try {
            allOutputData = yield requestDataWithAddress(
              MULTI_OUTPUTS_ADDRESS,
              MULTI_PART_COUNT
            );
          } catch (e) {
            allOutputData = [1, 1, 1, 1, 1, 1, 1, 1];
          }
          const newOutputData = [...allOutputData];
          newOutputData[part] = output;
          yield sendData(MULTI_OUTPUTS_ADDRESS, newOutputData);
        }));
      });
    },
    /**
     * Set level for a multi mode part.
     * Uses WSD/DAT/EOD protocol (DT1 does not work for function parameters).
     */
    setMultiLevel(part, level) {
      return __async(this, null, function* () {
        if (part < 0 || part > 7) {
          throw new Error(`Invalid part number: ${part} (must be 0-7)`);
        }
        if (level < 0 || level > 127) {
          throw new Error(`Invalid level: ${level} (must be 0-127)`);
        }
        return serialize(() => __async(null, null, function* () {
          const allLevelData = yield requestDataWithAddress(
            MULTI_LEVELS_ADDRESS,
            MULTI_PART_COUNT
          );
          const newLevelData = [...allLevelData];
          newLevelData[part] = level;
          yield sendData(MULTI_LEVELS_ADDRESS, newLevelData);
        }));
      });
    },
    // === MIDI Panic ===
    panic() {
      for (let channel = 0; channel < 16; channel++) {
        midiAdapter.send([176 + channel, 123, 0]);
        midiAdapter.send([176 + channel, 120, 0]);
      }
    },
    // === Individual Patch Parameter Setters ===
    setPatchName(patchIndex, name) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "name");
        const encoded = new Array(12).fill(32);
        for (let i = 0; i < Math.min(name.length, 12); i++) {
          encoded[i] = name.charCodeAt(i) & 127;
        }
        yield bufferWrite(address, encoded);
      });
    },
    setPatchKeyMode(patchIndex, keyMode) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "keyMode");
        const modes = { normal: 0, "v-sw": 1, "x-fade": 2, "v-mix": 3, unison: 4 };
        yield bufferWrite(address, [modes[keyMode]]);
      });
    },
    setPatchBenderRange(patchIndex, range) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "benderRange");
        yield bufferWrite(address, [Math.max(0, Math.min(12, range))]);
      });
    },
    setPatchAftertouchSens(patchIndex, sens) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "aftertouchSens");
        yield bufferWrite(address, [Math.max(0, Math.min(127, sens))]);
      });
    },
    setPatchAftertouchAssign(patchIndex, assign) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "aftertouchAssign");
        const assigns = {
          modulation: 0,
          volume: 1,
          "bend+": 2,
          "bend-": 3,
          filter: 4
        };
        yield bufferWrite(address, [assigns[assign]]);
      });
    },
    setPatchKeyAssign(patchIndex, assign) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "keyAssign");
        yield bufferWrite(address, [assign === "rotary" ? 0 : 1]);
      });
    },
    setPatchOutput(patchIndex, output) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "outputAssign");
        yield bufferWrite(address, [Math.max(0, Math.min(8, output))]);
      });
    },
    setPatchLevel(patchIndex, level) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "level");
        yield bufferWrite(address, [Math.max(0, Math.min(127, level))]);
      });
    },
    setPatchDetune(patchIndex, detune) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "detune");
        const unsigned = detune < 0 ? detune + 128 : detune;
        yield bufferWrite(address, [unsigned]);
      });
    },
    setPatchVelocityThreshold(patchIndex, threshold) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "velocityThreshold");
        yield bufferWrite(address, [Math.max(0, Math.min(127, threshold))]);
      });
    },
    setPatchVelocityMixRatio(patchIndex, ratio) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "velocityMixRatio");
        yield bufferWrite(address, [Math.max(0, Math.min(127, ratio))]);
      });
    },
    setPatchOctaveShift(patchIndex, shift) {
      return __async(this, null, function* () {
        const address = addressBuilders.buildPatchParamAddress(patchIndex, "octaveShift");
        const unsigned = shift < 0 ? shift + 128 : shift;
        yield bufferWrite(address, [unsigned]);
      });
    }
  };
}

// src/devices/roland-s-series/s-series-tone-factory.ts
function normalizeSampleRate(rate) {
  if (typeof rate === "number") {
    return rate === 3e4 ? "30kHz" : "15kHz";
  }
  return rate;
}
function buildDefaultToneBody(name, outputAssign, sampleRate, originalKey, transpose, effectivePitchFollow, velocitySensitivity) {
  return {
    name: name.slice(0, 8).toUpperCase().padEnd(8, " "),
    outputAssign,
    sampleRate,
    originalKey,
    lfo: {
      rate: 50,
      sync: false,
      delay: 0,
      mode: "normal",
      polarity: false,
      offset: 64
    },
    transpose,
    fineTune: 0,
    tvf: {
      cutoff: 127,
      resonance: 0,
      keyFollow: 0,
      lfoDepth: 0,
      egDepth: 0,
      egPolarity: "normal",
      levelCurve: 0,
      keyRateFollow: 0,
      velRateFollow: 0,
      enabled: false,
      envelope: {
        levels: [127, 127, 127, 127, 127, 127, 127, 127],
        rates: [127, 127, 127, 127, 127, 127, 127, 127],
        sustainPoint: 7,
        endPoint: 8
      }
    },
    tva: {
      lfoDepth: 0,
      keyRate: 0,
      level: 127,
      velRate: 0,
      levelCurve: Math.max(0, Math.min(5, velocitySensitivity)),
      envelope: {
        levels: [127, 127, 127, 127, 127, 127, 127, 0],
        rates: [127, 127, 127, 127, 127, 127, 127, 30],
        sustainPoint: 6,
        endPoint: 8
      }
    },
    benderEnabled: effectivePitchFollow,
    aftertouchEnabled: false,
    pitchFollow: effectivePitchFollow,
    recThreshold: 64,
    recPreTrigger: 0,
    loopTune: 0,
    envZoom: 0,
    copySource: 0
  };
}
function createSeriesTone(config) {
  const {
    name,
    sampleRate,
    waveBank,
    segmentTop,
    segmentLength,
    sampleCount,
    loopMode = "one-shot",
    loopPoint = 0,
    originalKey = 60,
    transpose = 0,
    pitchFollow,
    outputAssign = 0,
    velocitySensitivity = 0
  } = config;
  const effectivePitchFollow = pitchFollow != null ? pitchFollow : loopMode !== "one-shot";
  return __spreadProps(__spreadValues({}, buildDefaultToneBody(
    name,
    outputAssign,
    normalizeSampleRate(sampleRate),
    originalKey,
    transpose,
    effectivePitchFollow,
    velocitySensitivity
  )), {
    sourceTone: 0,
    origSubTone: 0,
    wave: {
      bank: waveBank,
      segmentTop,
      segmentLength,
      startPoint: 0,
      endPoint: Math.max(0, sampleCount - 1),
      loopPoint,
      loopLength: Math.max(0, sampleCount - 1 - loopPoint)
    },
    loopMode
  });
}
function createSeriesSubTone(config, limits) {
  const {
    name,
    sourceToneIndex,
    sampleRate,
    startPoint,
    endPoint,
    loopMode = "one-shot",
    loopPoint = startPoint,
    originalKey = 60,
    transpose = 0,
    pitchFollow,
    outputAssign = 0,
    velocitySensitivity = 0
  } = config;
  const effectivePitchFollow = pitchFollow != null ? pitchFollow : loopMode !== "one-shot";
  return __spreadProps(__spreadValues({}, buildDefaultToneBody(
    name,
    outputAssign,
    normalizeSampleRate(sampleRate),
    originalKey,
    transpose,
    effectivePitchFollow,
    velocitySensitivity
  )), {
    sourceTone: sourceToneIndex & limits.sourcetoneMask,
    origSubTone: 1,
    wave: {
      bank: 0,
      segmentTop: 0,
      segmentLength: 0,
      startPoint,
      endPoint,
      loopPoint,
      loopLength: Math.max(0, endPoint - loopPoint)
    },
    loopMode
  });
}
function createSeriesMonolithicPrimaryTone(config, startPoint, endPoint) {
  const tone = createSeriesTone(config);
  tone.wave.startPoint = startPoint;
  tone.wave.endPoint = endPoint;
  tone.wave.loopPoint = startPoint;
  tone.wave.loopLength = endPoint - startPoint;
  tone.sourceTone = 0;
  tone.origSubTone = 0;
  return tone;
}

// src/devices/s550/s550-addresses.ts
var ROLAND_ID2 = ROLAND_ID;
var S550_MODEL_ID = S_SERIES_MODEL_ID;
var DEFAULT_DEVICE_ID2 = DEFAULT_DEVICE_ID;
var S550_COMMANDS = S_SERIES_COMMANDS;
var ERROR_CODES2 = ERROR_CODES;
var TIMING2 = TIMING;
var BULK_DUMP_TYPES2 = BULK_DUMP_TYPES;
var calculateChecksum2 = calculateChecksum;
var PATCH_PARAMS2 = PATCH_PARAMS;
var PATCH_COMMON_OFFSETS2 = PATCH_COMMON_OFFSETS;
var TONE_OFFSETS2 = TONE_OFFSETS;
var PATCH_TOTAL_SIZE2 = PATCH_TOTAL_SIZE;
var TONE_BLOCK_SIZE2 = TONE_BLOCK_SIZE;
var TONE_BLOCK_NIBBLES2 = TONE_BLOCK_NIBBLES;
var TONE_MAP_ENTRIES2 = TONE_MAP_ENTRIES;
var buildPatchAddress2 = buildPatchAddress;
var buildPatchParamAddress2 = buildPatchParamAddress;
var buildToneAddress2 = buildToneAddress;
var buildSystemAddress2 = buildSystemAddress;
var ADDR_SYSTEM = [0, 0, 0, 0];
var ADDR_PATCH_BASE = [0, 0, 0, 0];
var ADDR_TONE_BASE = [0, 3, 0, 0];
var TONE_STRIDE = 2;
var ADDR_WAVE_DATA = [1, 0, 0, 0];
var SYSTEM_OFFSETS = {
  MASTER_TUNE: 0,
  MASTER_LEVEL: 1,
  MIDI_CHANNEL: 2,
  DEVICE_ID: 3,
  EXCLUSIVE_ENABLE: 4,
  PROG_CHANGE_ENABLE: 5,
  CTRL_CHANGE_ENABLE: 6,
  BENDER_ENABLE: 7,
  MOD_WHEEL_ENABLE: 8,
  AFTERTOUCH_ENABLE: 9,
  HOLD_PEDAL_ENABLE: 10
};
var SYSTEM_BLOCK_SIZE = 11;
var MAX_PATCHES = 32;
var MAX_TONES = 64;
var VALUE_RANGES2 = __spreadProps(__spreadValues({}, VALUE_RANGES), {
  /** Tone number range (S-550: 0-63) */
  TONE_NUMBER: { min: 0, max: 63 },
  /** Patch number range (S-550: 0-31) */
  PATCH_NUMBER: { min: 0, max: 31 },
  /** Wave bank range (S-550: 0-3) */
  WAVE_BANK: { min: 0, max: 3 }
});
var WAVE_BANK_BASE_ADDRESSES = {
  0: 0,
  // Bank A
  1: 32,
  // Bank B
  2: 64,
  // Bank C
  3: 96
  // Bank D
};
function buildWaveDataAddress(absoluteWaveBank, segmentIndex) {
  if (absoluteWaveBank < 0 || absoluteWaveBank > 3) {
    throw new Error(`Wave bank ${absoluteWaveBank} out of range (0-3)`);
  }
  if (segmentIndex < 0 || segmentIndex > 17) {
    throw new Error(`Segment index ${segmentIndex} out of range (0-17)`);
  }
  const byte1 = WAVE_BANK_BASE_ADDRESSES[absoluteWaveBank];
  const byte2 = segmentIndex * 8 & 127;
  return [1, byte1, byte2, 0];
}
function buildBlockRelativeWaveAddress(block, blockRelativeBank, segmentIndex) {
  const absoluteBank = block === 1 ? blockRelativeBank : blockRelativeBank + 2;
  return buildWaveDataAddress(absoluteBank, segmentIndex);
}

// src/devices/s550/s550-blocks.ts
function getBlockForTone(absoluteToneIndex) {
  if (absoluteToneIndex < 0 || absoluteToneIndex > 63) {
    throw new Error(`Tone index ${absoluteToneIndex} out of range (0-63)`);
  }
  return absoluteToneIndex < TONES_PER_BLOCK ? 1 : 2;
}
function getBlockInfo(block) {
  return BLOCK_INFO[block];
}
function isToneInBlock(absoluteToneIndex, block) {
  const info = BLOCK_INFO[block];
  return absoluteToneIndex >= info.firstToneIndex && absoluteToneIndex <= info.lastToneIndex;
}
function getBlockRelativeToneIndex(absoluteToneIndex) {
  if (absoluteToneIndex < 0 || absoluteToneIndex > 63) {
    throw new Error(`Tone index ${absoluteToneIndex} out of range (0-63)`);
  }
  return absoluteToneIndex % TONES_PER_BLOCK;
}
function getAbsoluteToneIndex(blockRelativeIndex, block) {
  if (blockRelativeIndex < 0 || blockRelativeIndex > 31) {
    throw new Error(`Block-relative tone index ${blockRelativeIndex} out of range (0-31)`);
  }
  const info = BLOCK_INFO[block];
  return info.firstToneIndex + blockRelativeIndex;
}
function getAbsoluteWaveBank(blockRelativeBank, block) {
  return BLOCK_WAVE_BANKS[block][blockRelativeBank];
}
function getBlockRelativeWaveBank(absoluteBank) {
  if (absoluteBank <= 1) {
    return { block: 1, bankIndex: absoluteBank };
  } else {
    return { block: 2, bankIndex: absoluteBank - 2 };
  }
}
function getBlockForWaveBank(absoluteBank) {
  return absoluteBank <= 1 ? 1 : 2;
}
function isWaveBankInBlock(absoluteBank, block) {
  const blockBanks = BLOCK_WAVE_BANKS[block];
  return blockBanks.includes(absoluteBank);
}
var WAVE_BANK_NAMES = ["A", "B", "C", "D"];
function getWaveBankName(absoluteBank) {
  return WAVE_BANK_NAMES[absoluteBank];
}
function parseWaveBankName(name) {
  const index = WAVE_BANK_NAMES.indexOf(name);
  if (index === -1) {
    throw new Error(`Invalid wave bank name: ${name}`);
  }
  return index;
}
function isValidWaveBankForTone(absoluteToneIndex, absoluteWaveBank) {
  const block = getBlockForTone(absoluteToneIndex);
  return isWaveBankInBlock(absoluteWaveBank, block);
}
function getValidWaveBanksForTone(absoluteToneIndex) {
  const block = getBlockForTone(absoluteToneIndex);
  return BLOCK_WAVE_BANKS[block];
}

// src/devices/s550/s550-params.ts
var parseSystemParams = (data) => parseSeriesSystemParams(data);
var encodeSystemParams = (params) => encodeSeriesSystemParams(params);
var parsePatchCommon = (data) => parseSeriesPatchCommon(data, PATCH_PARAMS2);
var encodePatchCommon = (params) => encodeSeriesPatchCommon(params, PATCH_PARAMS2);
var createEmptyPatchCommon = (_index) => createEmptySeriesPatchCommon();
var parseTone = (data) => parseSeriesTone(data, TONE_OFFSETS2);
var encodeTone = (tone) => encodeSeriesTone(tone, TONE_OFFSETS2, TONE_BLOCK_SIZE2, S550_DEVICE_LIMITS);
var isValidPatchNumber = (num) => num >= 0 && num <= S550_DEVICE_LIMITS.maxPatchNumber;
var isValidToneNumber = (num) => num >= 0 && num <= S550_DEVICE_LIMITS.maxToneNumber;

// src/devices/s550/s550-tone-factory.ts
function createTone(config) {
  return createSeriesTone(config);
}
function createSubTone(config) {
  return createSeriesSubTone(config, S550_DEVICE_LIMITS);
}
function createMonolithicPrimaryTone(config, startPoint, endPoint) {
  return createSeriesMonolithicPrimaryTone(config, startPoint, endPoint);
}

// src/devices/s550/s550-client.ts
var S550_ADDRESS_BUILDERS = {
  buildPatchAddress(patchIndex) {
    return [0, 0, patchIndex * 4 & 127, 0];
  },
  buildToneAddress(toneIndex) {
    const byte2 = toneIndex * TONE_STRIDE;
    return [0, 3, byte2 & 127, 0];
  },
  buildPatchParamAddress(patchIndex, paramName) {
    const param = PATCH_PARAMS2[paramName];
    if (!param) {
      throw new Error(`Unknown patch parameter: ${paramName}`);
    }
    const [high, low] = param.address;
    return [0, 0, patchIndex * 4 + high & 127, low & 127];
  },
  buildWaveDataAddress(waveBank, segmentIndex) {
    return buildWaveDataAddress(waveBank, segmentIndex);
  }
};
var S550_PARSERS = {
  parsePatchCommon,
  parseTone,
  encodePatchCommon,
  encodeTone,
  createTone(params) {
    return createTone(__spreadProps(__spreadValues({}, params), {
      waveBank: params.waveBank
    }));
  },
  getPatchCommon(patch) {
    return patch.common;
  },
  createPatch(common) {
    return { common };
  },
  getToneWave(tone) {
    return tone.wave;
  },
  setToneWave(tone, wave) {
    return __spreadProps(__spreadValues({}, tone), { wave });
  }
};
function createS550Client(midiAdapter, options = {}) {
  return createSSeriesClient(
    S550_CONFIG,
    midiAdapter,
    S550_PARSERS,
    S550_ADDRESS_BUILDERS,
    PATCH_PARAMS2,
    options
  );
}
export {
  ADDR_PATCH_BASE,
  ADDR_SYSTEM,
  ADDR_TONE_BASE,
  ADDR_WAVE_DATA,
  BLOCK_COUNT,
  BLOCK_INFO,
  BLOCK_WAVE_BANKS,
  BULK_DUMP_TYPES2 as BULK_DUMP_TYPES,
  DEFAULT_DEVICE_ID2 as DEFAULT_DEVICE_ID,
  ERROR_CODES2 as ERROR_CODES,
  MAX_PATCHES,
  MAX_TONES,
  PATCH_COMMON_OFFSETS2 as PATCH_COMMON_OFFSETS,
  PATCH_PARAMS2 as PATCH_PARAMS,
  PATCH_TOTAL_SIZE2 as PATCH_TOTAL_SIZE,
  ROLAND_ID2 as ROLAND_ID,
  S550_ADDRESSES,
  S550_COMMANDS,
  S550_CONFIG,
  S550_MODEL_ID,
  SYSTEM_BLOCK_SIZE,
  SYSTEM_OFFSETS,
  TIMING2 as TIMING,
  TONES_PER_BLOCK,
  TONE_BLOCK_NIBBLES2 as TONE_BLOCK_NIBBLES,
  TONE_BLOCK_SIZE2 as TONE_BLOCK_SIZE,
  TONE_MAP_ENTRIES2 as TONE_MAP_ENTRIES,
  TONE_OFFSETS2 as TONE_OFFSETS,
  TONE_STRIDE,
  VALUE_RANGES2 as VALUE_RANGES,
  WAVE_BANKS_PER_BLOCK,
  WAVE_BANK_ADDRESSES,
  WAVE_BANK_BASE_ADDRESSES,
  WAVE_BANK_NAMES,
  buildACKMessage,
  buildBlockRelativeWaveAddress,
  buildDATMessage,
  buildDT1Message,
  buildEODMessage,
  buildERRMessage,
  buildPatchAddress2 as buildPatchAddress,
  buildPatchParamAddress2 as buildPatchParamAddress,
  buildRJCMessage,
  buildRQDMessage,
  buildSystemAddress2 as buildSystemAddress,
  buildToneAddress2 as buildToneAddress,
  buildWSDMessage,
  buildWaveDataAddress,
  calculateChecksum2 as calculateChecksum,
  calculateSegmentsNeeded,
  clamp7Bit,
  createEmptyPatchCommon,
  createMonolithicPrimaryTone,
  createS550Client,
  createSubTone,
  createTone,
  createWav,
  denibblize,
  encode21BitAddress,
  encode24BitAddress,
  encodeAftertouchAssign,
  encodeEgPolarity,
  encodeEnvelope,
  encodeKeyAssign,
  encodeKeyMode,
  encodeLfoMode,
  encodeLoopMode,
  encodeName,
  encodePatchCommon,
  encodeSampleRate,
  encodeSignedValue,
  encodeSize,
  encodeSystemParams,
  encodeTone,
  getAbsoluteToneIndex,
  getAbsoluteWaveBank,
  getBlockForTone,
  getBlockForWaveBank,
  getBlockInfo,
  getBlockRelativeToneIndex,
  getBlockRelativeWaveBank,
  getValidWaveBanksForTone,
  getWaveBankName,
  isToneInBlock,
  isValid7BitValue,
  isValidDeviceId,
  isValidMidiChannel,
  isValidPatchNumber,
  isValidToneNumber,
  isValidWaveBankForTone,
  isWaveBankInBlock,
  nibblize,
  parse21BitAddress,
  parse24BitAddress,
  parseAftertouchAssign,
  parseEgPolarity,
  parseEnvelope,
  parseKeyAssign,
  parseKeyMode,
  parseLevelCurve,
  parseLfoMode,
  parseLoopMode,
  parseName,
  parsePatchCommon,
  parseSampleRate,
  parseSignedValue,
  parseSystemParams,
  parseTone,
  parseWav,
  parseWaveBankName,
  prepareWavForSSeries,
  resample,
  seriesToWav,
  validateWaveDataFits,
  wavToSeries
};
//# sourceMappingURL=s550.js.map